import ecopack from "../Assets/ecopack.png";
import disena from "../Assets/disena.png";
import myquest from "../Assets/myquest.png";
import adools from "../Assets/adools.jpg";

/* One source of truth for the work. The homepage shows the
   featured cut; /projects shows the full index. */
export const projects = [
  {
    id: "myquest",
    title: "myQuest",
    discipline: "Mobile Application",
    year: "2025",
    role: "Design & Build",
    summary:
      "A cross-platform CBT exam prep app for Nigerian students, live on Google Play. AI-powered learning assistance, progress tracking, a scalable question bank and full offline support.",
    metrics: [
      { k: "Downloads", v: "1,000+" },
      { k: "Active users", v: "700+" },
    ],
    image: myquest,
    link: "https://play.google.com/store/apps/details?id=com.teemi2106.myquest",
    github: null,
    stack: ["React Native", "Expo", "Supabase", "PostgreSQL"],
    featured: true,
  },
  {
    id: "adools",
    title: "Adools Construct & Designs",
    discipline: "Marketing Site",
    year: "2025",
    role: "Frontend Developer",
    summary:
      "The full marketing site for an architecture, interior design and construction studio in Lagos. A Three.js 3D hero, GSAP scroll effects, parallax sections and a custom mega-nav with a Ventures sub-section.",
    image: adools,
    link: "https://adoolsdesign.com",
    github: null,
    stack: ["Next.js", "Tailwind CSS", "Three.js", "GSAP"],
    featured: true,
  },
  {
    id: "ecopack",
    title: "EcoPack",
    discipline: "Web Platform",
    year: "2024",
    role: "Design & Build",
    summary:
      "A responsive platform helping businesses discover and compare sustainable packaging options, with filtering and side-by-side comparison tooling.",
    image: ecopack,
    link: "https://eco-pack-one.vercel.app/",
    github: "https://github.com/Moduo1/ecopack",
    stack: ["React", "TypeScript", "Tailwind CSS"],
    featured: true,
  },
  {
    id: "disena",
    title: "Disena Creates",
    discipline: "Portfolio Site",
    year: "2024",
    role: "Design & Build",
    summary:
      "A portfolio for a creative studio. Projects, services and process, presented with the work doing the talking.",
    image: disena,
    link: "https://disena-creates.vercel.app/",
    github: null,
    stack: ["React", "TypeScript", "Tailwind CSS"],
    featured: false,
  },
];

/* Live work that is not yet a case study, shown as an
   "in progress" register so the site stays current. */
export const inProgress = [
  {
    title: "Reply",
    discipline: "AI SaaS",
    year: "2025",
    summary:
      "A WhatsApp AI assistant for Nigerian SMBs, handling automated customer conversations, order capture and follow-up.",
    stack: ["Next.js", "Python", "Upstash Redis"],
  },
];

export const featured = projects.filter((p) => p.featured);
